import { ZapierPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../../constants';

export default (): ZapierPointerParameterValue => ({
  type: PARAMETER_VALUE_TYPE.EVENT_CONTACT_APP_ZAPIER_POINTER,
  variable: null,
});
